<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
    <form class="kt-form w-webkit-fill-available" [formGroup]="form">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Create Reconciliation Job</h5>
                <span class="modal-x-button" (click)="onCloseDialog()">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </span>
            </div>
            <div class="modal-body">
                <div class="col-12 form-group row">
                    <label class="col-4 col-form-label">Transaction Timestamp<span class="text-danger">*</span><i class="fa fa-info-circle ml-1" placement="bottom" [ngbTooltip]="dateToolTip" tooltipClass="tooltip-class"></i></label>
                    <div class="col-8 input-group date">
                        <input type="text" class="form-control" formControlName="defaultDate" [timePicker]="false" [timePickerSeconds]="false" [opens]="'left'"  [alwaysShowCalendars]="false" [ranges]="ranges" [showCustomRangeLabel]="true" [locale]="{format: 'YYYY-MM-DD HH:mm:ss'}" [timePicker24Hour]="true" [showDropdowns]="true" ngxDaterangepickerMd/>
                    </div>
                </div>
                <ng-template #dateToolTip>
                    <div class="text-left">
                        The transaction timestamp will apply for bank's transaction filtered by transaction datetime and data from BO 7.2 filtered by "Created Date".
                    </div>
                </ng-template>
                <div class="col-12 form-group row">
                    <label class="col-lg-4 col-form-label">Type</label>
                    <div class="col-lg-8 col-form-label">
                        <div class="kt-radio-list row">
                            <label class="kt-radio mr-3"
                                *ngFor="let value of dropdown.botReconciliationType">
                            <input
                                type="radio"
                                formControlName="bot_reconciliation_type_id"
                                [value]="value.id"
                            />
                            {{ value.name }}
                            <span></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-12 form-group row">
                    <label class="col-4 control-label">Bank Account<span class="text-danger">*</span></label>
                    <kt-dropdown-wo-lazyload class="dropdown-maxheight col-8 merchant-bank-list" style="padding:0"
                        [form] = 'form'
                        [dropdownList] = 'filteredMerchantBankDropdownList'
                        [dropdownSettings] = 'merchantBankDropdownSettings'
                        [formName] = "'merchant_bank_id'"
                        [selectionAttributes] = "'id'"
                        [selectedItems] = 'merchantBankSelectedItems'>
                    </kt-dropdown-wo-lazyload>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>Close</button>
                <kt-submit-button *ngIf="canCreateReconciliationJob" [isDisabled]="!form.valid" [buttonLoading]="buttonLoading" (confirmed)="onSave()"></kt-submit-button>
            </div>
        </div>
    </form>
</div>
<kt-swal-alert [message]="messages$ | async" (confirmed)="onCloseDialog(true)"></kt-swal-alert>